import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DayTypeSelectorComponent } from './components/day-type-selector/day-type-selector.component';
import { SharedModule } from '../shared/shared.module';
import { LineSelectorComponent } from './components/line-selector/line-selector.component';
import { DirectionSelectorComponent } from './components/direction-selector/direction-selector.component';


@NgModule({
  declarations: [
    DayTypeSelectorComponent,
    LineSelectorComponent,
    DirectionSelectorComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule
  ],
  exports: [
    DayTypeSelectorComponent,
    LineSelectorComponent,
    DirectionSelectorComponent
  ],
  providers: [
  ]
})
export class ImporterStpModule { }
